export default "__VITE_ASSET__CqgB2ufw__"